import { useStaticQuery, graphql } from 'gatsby';

export default function useStaticMessages() {
    const data = useStaticQuery(graphql`
        query useGetFrontendMessages {
            magento {
                getFrontendMessages {
                    type
                    level
                    title
                    content
                }
            }
        }
    `);

    return data?.magento?.getFrontendMessages ?? [];
}
